export let props = ['labelWidth', 'labelShallow', 'label', 'separate']
export let model = {
  currentIndex: 1,
  currentData: undefined
}
export let computed = {
  labelStyle () {
    let width = 'width:' + (this.labelWidth ? this.labelWidth : '80px') + ';'
    let align = 'text-align:' + (this.labelAlign ? this.labelAlign : 'right')
    return width + align
  }
}
